var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-row",
    [
      _c(
        "w-col",
        { attrs: { xs: "12" } },
        [
          _c(
            "w-card",
            [
              _c("w-card-title", [_vm._v(_vm._s(_vm.$ct("payments")))]),
              _c(
                "w-card-content",
                [
                  _c(
                    "w-row",
                    [
                      _c(
                        "w-col",
                        { attrs: { xs: "12" } },
                        [
                          _c("app-select-free-line-placement", {
                            attrs: {
                              label: _vm.$ct("placement"),
                              "include-none": "",
                            },
                            model: {
                              value: _vm.layout.Payments.Placement,
                              callback: function ($$v) {
                                _vm.$set(_vm.layout.Payments, "Placement", $$v)
                              },
                              expression: "layout.Payments.Placement",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "w-sortable",
                {
                  attrs: {
                    items: _vm.layout.Payments.Cols,
                    tag: "w-list",
                    "target-class": "handle",
                  },
                },
                [
                  _vm._l(_vm.layout.Payments.Cols, function (row, i) {
                    return _c(
                      "w-list-item",
                      { key: i, attrs: { "show-handle": "" } },
                      [
                        _c("w-list-item-text", [
                          _vm._v(
                            " " +
                              _vm._s(row.getText(_vm.selectedLanguage)) +
                              " "
                          ),
                          row.HeaderField
                            ? _c("span", { staticClass: "bold" }, [
                                _vm._v(
                                  "(" +
                                    _vm._s(
                                      row.getHeadingText(_vm.selectedLanguage)
                                    ) +
                                    ")"
                                ),
                              ])
                            : _vm._e(),
                        ]),
                        _c(
                          "w-list-item-action",
                          { style: { flexGrow: 1 } },
                          [
                            _c("w-input-number", {
                              staticClass: "mr",
                              attrs: { label: _vm.$ct("position"), fancy: "" },
                              model: {
                                value: row.Position,
                                callback: function ($$v) {
                                  _vm.$set(row, "Position", $$v)
                                },
                                expression: "row.Position",
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "w-list-item-action",
                          { style: { flexGrow: 1 } },
                          [
                            _c("w-input-number", {
                              staticClass: "mr",
                              attrs: { label: _vm.$ct("width"), fancy: "" },
                              model: {
                                value: row.Width,
                                callback: function ($$v) {
                                  _vm.$set(row, "Width", $$v)
                                },
                                expression: "row.Width",
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "w-list-item-action",
                          [
                            _c(
                              "w-button",
                              {
                                directives: [
                                  {
                                    name: "tooltip",
                                    rawName: "v-tooltip",
                                    value: _vm.$ct(`tooltip.line-edit`),
                                    expression: "$ct(`tooltip.line-edit`)",
                                  },
                                ],
                                on: {
                                  click: function ($event) {
                                    return _vm.edit(row)
                                  },
                                },
                              },
                              [_c("w-fa", { attrs: { icon: "pen" } })],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "w-list-item-action",
                          [
                            _c(
                              "w-button",
                              {
                                directives: [
                                  {
                                    name: "tooltip",
                                    rawName: "v-tooltip",
                                    value: _vm.$ct(`tooltip.line-remove`),
                                    expression: "$ct(`tooltip.line-remove`)",
                                  },
                                ],
                                staticClass: "danger",
                                on: {
                                  click: function ($event) {
                                    return _vm.removeColumn(i)
                                  },
                                },
                              },
                              [_c("w-fa", { attrs: { icon: "trash" } })],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  }),
                  _c(
                    "w-list-item",
                    {
                      on: {
                        click: function ($event) {
                          return _vm.addColumn()
                        },
                      },
                    },
                    [
                      _c("w-list-item-text", [
                        _c(
                          "div",
                          [
                            _c("w-fa", { attrs: { icon: "plus" } }),
                            _vm._v(" " + _vm._s(_vm.$ct("add-column")) + " "),
                          ],
                          1
                        ),
                      ]),
                    ],
                    1
                  ),
                ],
                2
              ),
              _vm.toEditCol != null
                ? _c(
                    "w-modal",
                    { attrs: { value: _vm.toEditCol != null } },
                    [
                      _c("app-payment-col-settings", {
                        attrs: {
                          "selected-language": _vm.selectedLanguage,
                          value: _vm.toEditCol,
                        },
                        on: {
                          "update:selectedLanguage": function ($event) {
                            _vm.selectedLanguage = $event
                          },
                          "update:selected-language": function ($event) {
                            _vm.selectedLanguage = $event
                          },
                          close: function ($event) {
                            _vm.toEditCol = null
                          },
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }